import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Input from '../../core/Input';
import { isEmail, required } from './validate';

const EmailFieldComponent = (props) => {
  const {
    input, meta, disabled, readOnly, label, helpText, busy,
  } = props;
  const { touched, error } = meta;
  const errorMessage = touched && error ? error : '';
  // Disabled inputs cause Chromium / LastPass to move the credential icon to the
  // left. While busy, keep the field enabled but read-only so the icon stays on the right.
  // Do not toggle type, autocomplete, or inputMode while busy — those changes make
  // password managers tear down and re-inject the field icon for a few seconds.
  const inputDisabled = busy ? false : disabled;
  const inputReadOnly = busy ? true : readOnly;
  return (
    <Input
      id="email"
      label={label}
      helpText={helpText}
      errorMessage={errorMessage}
      {...input}
      disabled={inputDisabled}
      readOnly={inputReadOnly}
      type="email"
      busy={busy}
      autoComplete={input.autoComplete}
    />
  );
};

const EmailField = ({
  name,
  label,
  disabled,
  readOnly,
  busy,
  helpText,
}) => (
  <Field
    name={name}
    component={EmailFieldComponent}
    disabled={disabled}
    readOnly={readOnly}
    busy={busy}
    label={label}
    validate={[required, isEmail]}
    helpText={helpText}
  />
);

EmailField.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  busy: PropTypes.bool,
  label: PropTypes.string,
  helpText: PropTypes.string,
};

EmailField.defaultProps = {
  disabled: false,
  readOnly: false,
  busy: false,
  label: 'Email Address',
  helpText: undefined,
};

export default EmailField;
export { EmailFieldComponent };
